import { render, staticRenderFns } from "./NoLongerSellingAlert.vue?vue&type=template&id=fafc455c&"
import script from "./NoLongerSellingAlert.vue?vue&type=script&lang=js&"
export * from "./NoLongerSellingAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports